import {
  createContext,
  useContext,
  useState,
  ReactNode,
} from "react";

/* ==================== Types ==================== */

interface SidebarContextValue {
  collapsed: boolean;
  toggleSidebar: () => void;
}

interface SidebarProviderProps {
  children: ReactNode;
}

/* ==================== Context ==================== */

const SidebarContext = createContext<SidebarContextValue | undefined>(
  undefined
);

/* ==================== Provider ==================== */

export const SidebarProvider = ({ children }: SidebarProviderProps) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const toggleSidebar = () => setCollapsed((prev) => !prev);

  return (
    <SidebarContext.Provider value={{ collapsed, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

/* ==================== Hook ==================== */

export const useSidebar = (): SidebarContextValue => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
